document.addEventListener('DOMContentLoaded', function () {
  console.log('loaded');

  const galleryHuge = document.querySelectorAll(
    '.main-gallery'
  );
  const buttonZoom = document.querySelector(
    '.media-gallery__zoom-dialog-button .btn'
  );

  if (galleryHuge.length > 0 && buttonZoom) {
    console.log('has');

    galleryHuge.forEach(element => {
        console.log(element);
        console.log(buttonZoom);
      element.addEventListener('click', function () {
        console.log('clicked');
        buttonZoom.click();
      });
    });
  }
});